document.addEventListener("DOMContentLoaded", function () {
  const currency = getCookie("cart_currency");
  const targetCurrencies = ["USD", "CAD", "AUD", "MXN"];
  if (!currency || !targetCurrencies.includes(currency.toUpperCase())) return;

  const priceContainer = document.getElementById("ProductPrice");
  if (!priceContainer) return;

  const label = document.createElement("div");
  label.className = "gap-currency-note";
  label.textContent = "Prices shown in: " + currency.toUpperCase();

  priceContainer.insertAdjacentElement("afterend", label);

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
    }
    return null;
  }
});
